export default __webpack_public_path__ + "ddb346468ed4ad80414a0af025019451.jpg";